export default {
  $vuetify: {
    badge: 'バッジ',
    close: '閉じる',
    dataIterator: {
      noResultsText: '検索結果が見つかりません。',
      loadingText: '項目をロード中です...',
    },
    dataTable: {
      itemsPerPageText: '1ページあたりの行数：',
      ariaLabel: {
        sortDescending: '降順の並び替え。',
        sortAscending: '昇順の並び替え。',
        sortNone: 'ソートされていません。',
        activateNone: 'ソートを削除するには有効にしてください。',
        activateDescending: '降順の並び替えのためには有効にしてください。',
        activateAscending: '昇順のソートのためには有効にしてください。',
      },
      sortBy: 'ソート方式',
    },
    dataFooter: {
      itemsPerPageText: '1ページあたりの件数：',
      itemsPerPageAll: 'すべて',
      nextPage: '次のページ',
      prevPage: '前のページ',
      firstPage: '最初のページ',
      lastPage: '最後のページ',
      pageText: '{0}-{1} 件目 / {2}件',
    },
    datePicker: {
      itemsSelected: '{0}日付選択',
      nextMonthAriaLabel: '来月',
      nextYearAriaLabel: '来年',
      prevMonthAriaLabel: '前月',
      prevYearAriaLabel: '前年',
    },
    noDataText: 'データはありません。',
    carousel: {
      prev: '前のビジュアル',
      next: '次のビジュアル',
      ariaLabel: {
        delimiter: 'カルーセルのスライド {0}件目 / {1}件',
      },
    },
    calendar: {
      moreEvents: 'さらに{0}',
    },
    fileInput: {
      counter: '{0} ファイル',
      counterSize: '{0} ファイル (合計 {1})',
    },
    timePicker: {
      am: 'AM',
      pm: 'PM',
    },
    pagination: {
      ariaLabel: {
        wrapper: 'ページネーションナビゲーション',
        next: '次のページ',
        previous: '前のページ',
        page: '{0}ページ目に移動',
        currentPage: '現在のページ、ページ {0}',
      },
    },
    rating: {
      ariaLabel: {
        icon: '評価 {1} のうち {0}',
      },
    },
  },
  errors: {
    login: {
      401: "無効な資格情報",
      403: "無効な資格情報",
      500: "エラーが発生しました。後でもう一度ログインしてみてください",
      503: "現在アップデートをアップロードしています。しばらくしてからもう一度ログインしてみてください",
    }
  },
  navigation: {
    selectAll: "すべて選択",
    route: {
      forms: "フォーム",
      users: "セッション",
      tenants: "機関",
      repliesLog: "返信ログ"
    }
  },
  login: {
    actions: {
      forgotPassword: "パスワードを忘れた？",
      login: "支払い",
      backToLogin: "ログインに戻る",
      recoverPassword: "パスワードを回復"
    },
    form: {
      fields: {
        username: "Eメール",
        password: "パスワード",
        email: "Eメール"
      },
      validations: {
        username: {
          required: "ユーザー名を入力する必要があります"
        },
        password: {
          required: "パスワードを入力する必要があります"
        }
      }
    }
  },
  users: {
    title: "セッション",
    actions: {
      add: "追加"
    },
    headers: {
      email: "郵便",
      name: "名前",
      tenant: "組織",
      title: "役職",
      lastLogin: "前回のログイン",
      id: "Id",
      givenName: "名前",
      lastName: "苗字",
      role: "役割",
      actions: "行動"
    },
    form: {
      add: "新しいユーザー",
      roleChange: "役割の変更",
      fields: {
        givenName: "名前",
        familyName: "苗字",
        email: "メール",
        username: "ユーザー",
        tenant: "テナント",
        role: "役割",
      },
      actions: {
        save: "保つ",
        cancel: "キャンセル"
      },
      roles: {
        admin: "管理者",
        maintainer: "メンテナ",
        user: "ユーザー"
      }
    }
  },
  tenants: {
    title: "テナント",
    actions: {
      add: "追加"
    },
    headers: {
      id: "Id",
      name: "名前",
      description: "説明",
      contact_person: "連絡先",
      actions: "行動"
    },
    form: {
      add: "新しいテナント",
        fields: {
        name: "名前",
        description: "説明",
        contactPerson: "連絡先",
      },
      actions: {
        save: "保つ",
        cancel: "キャンセル"
      }
    }
  },
  replyLogs: {
    title: "返信",
    actions: {
      create: "作成した",
      edit: "編集済み",
      title: {
        edit: "編集された質問",
        create: "回答済みの質問"
      }
    },
    headers: {
      formName: "形",
      id: "ID",
      userName: "ユーザー",
      tenantName: "組織",
      createdAt: "日にち",
      action: "アクション"
    }
  },
  forms: {
    title: "フォーム",
    noDataMessage: "利用可能なフォームはありません",
    submitted: "あなたの応答は記録されました。",
    closedEdit: "回答は編集されていません。次のボタンで新しい回答を作成できます",
    copyLink: "リンクがクリップボードにコピーされました",
    delete: {
      title: "フォームを削除します",
      message: "フォームを削除してよくよくわかります",
      action: "デリート"
    },
    actions: {
      add: "追加",
      organizations: "組織",
      otherResponse: "その他の回答",
      edit: "編集",
      delete: "削除する",
      submit: "返信を送信する",
      replies: "返信",
      downloadExcel: "回答をダウンロード",
      shareLink: "回答フォームへのリンクを共有する",
      shareLinkShort: "共有リンク",
      downloadJson: "JSONをダウンロード",
      goToHome: "ホームページ",
    },
    tabs: {
      formSettings: "設定",
      newForm: "フォームの作成",
      preview: "プレビュー"
    },
    headers: {
      answers: "回答",
      lastUpdate: "最終変更",
    },
    defaultData: {
      id: {
        text: "ID"
      },
      name: {
        text: "名前"
      }
    },
    replies: {
      title: "返信",
      headers: {
        id: "ID",
        createdAt: "作成場所",
        updatedAt: "で更新",
        createdBy: "によって作成された",
        actions: "行動",
      }
    },
    downloadExcel: {
      title: "データを取得する組織を選択します",
      confirmTitle: "このテナントのデータをダウンロードしてもよろしいですか？",
      tenants: "テナント",
      selectAll: "すべて選択",
      actions: {
        download: "Excelをダウンロードする"
      }
    },
    form: {
      add: "新しいフォーム",
      groups: "グループの選択",
      sendToJoin: "保存してJoinに送信",
      next: "次",
      noGroups: "Joinにグループが登録されていません。 Joinでグループを作成し、再試行してください。",
      sendReplyTo: "このグループに答えを送ってよろしいですか？",
      sendEditReplyTo: "このグループに答えを送ってよろしいですか？",
      save: "保つ",
      loadJSON: "JSONをロード",
      edited: "編集済み",
      sendEdit: "編集を送信",
      imageLoaded: "画像",
      actions: {
        save: "保つ",
        cancel: "キャンセル",
        newQuestion: "新しい質問",
        search: "検索",
        clearForm: "明確な形",
        clearSection: "クリアセクション",
        copy: "質問をコピーする",
        delete: "質問を削除",
        uploadImage: "画像をアップロード",
        deleteImage: "画像を削除する",
        closeEdit: "選ぶ"
      },
      default: {
        untitledForm: "無題のフォーム",
        option1: "オプション1",
      },
      confirmation: {
        deleteMandatory: "また、必須フィールドを削除します。 （編集可能のみ）",
        section: {
          title: "クリーンセクション",
          description: "現在のセクションをクリアしてもよろしいですか？ 入力したデータは後で取得できません。",
          action: "クリーンセクション"
        },
        form: {
          title: "クリーンフォーム",
          description: "フォーム全体をきれいにしてよろしいですか？ 入力したデータは後で取得できません。",
          action: "クリーンフォーム"
        },
      },
      questions: {
        shortAnswer: "短い答え",
        paragraph: "段落",
        multipleChoice: "複数の選択肢",
        checkboxes: "複数の回答",
        dropdown: "フィールドを選択",
        linearScale: "線形スケール",
        date: "日付ピッカー",
        time: "時間セレクター",
        section: "セクション"
      },
      fields: {
        title: "資格",
        description: "説明",
        question: "質問",
        shortAnswerText: "短い回答テキスト",
        longAnswerText: "長い回答テキスト",
        optionText: "オプションテキスト",
        addOption: "オプションを追加",
        from: "から",
        to: "それまで",
        labelFrom: "からのラベル",
        labelTo: "ラベルアップ",
        date: "日にち",
        time: "時間",
        required: "必須",
        organizations: "組織",
        photo: "フォーム画像",
        section: "セクション",
        validations: "検証",
        score: "スコア付きフォーム",
        scoreRuleStatus: "ルール",
        scoreLabel: "スコア",
        editable: "編集可能"
      },
      preview: {
        selectGroup: "グループを選択",
        yourAnswer: "答え",
        chooseOption: "オプションを選択",
        pickDate: "日付を選択してください",
        pickTime: "時間を選択してください",
        submit: "送信",
        edit: "編集",
        clearForm: "すっきりとしたフォルム",
        totalScore: "合計スコア"
      },
      reply: {
        editUrl: "回答を編集する"
      },
      scoreRules: {
        headers: {
          value: "価値",
          operator: "オペレーター",
          title: 'タイトル',
          description: "説明",
        },
        actions: {
          addRule: "別のルールを追加する"
        }
      },
      validations: {
        default: "これは必須の質問です",
        required: "この項目は必須です",
        email: "有効なメールアドレスを入力する必要があります",
        phone: "有効な電話番号を入力する必要があります",
        rut: "有効な轍を入力する必要があります",
        scoreValidNumber: "スコアは0から9の間でなければなりません",
        fileSizeError: "ファイルは最大5Mbである必要があります。",
        fileUnsupportedFile: "入力されたファイルのタイプはサポートされていません。",
        noTenantsSelected: "このフォームを少なくとも1つのテナントに割り当てる必要があります。",
        options: {
          email: "Eメール",
          phone: "電話番号",
          rut: "Rut",
          regex: "正規表現",
        },
      }
    }
  },

}
